import '../data-table';

export default (ctx, html) => html`
  <data-table
    .styles="${ctx.styles}"
    .config="${ctx.config}"
    ?select-all="${ctx.allSelected}"
    .results="${ctx.results}"
    @change-sort="${ctx.changeSortHandler}"
    @row-click="${ctx.rowClickHandler}"
    @row-toggle="${ctx.rowToggleHandler}"
    @all-toggle="${ctx.allToggleHandler}"
    @page-toggle="${ctx.pageToggleHandler}"
    @persistent-selection-toggle="${ctx.persistentSelectionToggleHandler}"
    ?disable-selection="${ctx['disable-selection']}"
    aria-label="${ctx['aria-label']}"
  ></data-table>
`;
